.workflow-view-detail-filter-buttons {
  padding: 0 0.8rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
}

.workflow-view__details-container {
  display: flex;
  flex-direction: column;
  height: '100%';
}

.workflow-view__details-container ion-item-divider {
  --background: transparent;
  --color: var(--ion-text-color);
  --padding-start: 0px;
  --inner-padding-end: 0px;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--background-color-step-200);
  display: flex;
  flex-direction: column;
}

.workflow-view__details-container ion-list {
  background: transparent;
  padding: 0;
}

.workflow-view__details-placeholder {
  color: var(--background-color-step-400);
}

.workflow-view__details-container ion-item {
  --background: transparent;
  --padding-start: 0px;
  --inner-padding-end: 0px;
  --inner-border-width: 0px;
  --min-height: 0px;
}

.workflow-view__details-container ion-label {
  margin-top: 0px;
  margin-bottom: 0px;
}

.workflow-view__details-container ion-item-group {
  flex: 1;
  padding: 0.2rem 0rem;
  width: 100%;
}

@media (max-width: 767px) {
  .workflow-view-comments-card__filters {
    flex-direction: column;
  }

  .workflow-view-detail-filter-buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
  }

  .submital-detail-filter-name {
    align-self: flex-start;
  }
}

.workflow-view-comments-card__filters.mobile-layout {
  flex-direction: column;
}

.workflow-view-comments-card__filters.mobile-layout .workflow-view-detail-filter-buttons {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}

.workflow-view-comments-card__filters.mobile-layout .submital-detail-filter-name {
  align-self: flex-start;
}

.workflow-view-detail-feed-container {
  border-top: 1px solid var(--background-color-step-150);
}

.workflow-view-detail-info-container {
  border: 1px solid var(--background-color-step-150);
  border-top-left-radius: 1rem;
  background-color: var(--background-color-step-50);
  padding: 0.5rem 0.25rem;
}

.workflow-view__content-container {
  overflow: 'hidden';
}

.workflow-view__left-column {
  height: 100%;
}

.workflow-view__timeline-container {
  flex: 0 0 auto;
}

.workflow-view__comments-container {
  min-height: 0;
}
